// extracted by mini-css-extract-plugin
export default {"element":"Loader_element__KZPg2","anima":"Loader_anima__WK8kb","circle":"Loader_circle__DzuXv","scale":"Loader_scale__2wcB6"};